import React, { Suspense, lazy } from "react";
import { Routes, Route, BrowserRouter } from "react-router-dom";
import PageLoader from "../components/PageLoader";

// PLAN-004 Phase 3.1: Lazy-load sub-routers for code splitting
const PrivateRouter = lazy(() => import("./PrivateRouter"));
const ProfesionalRouter = lazy(() => import("./ProfesionalRouter"));
const OngRouter = lazy(() => import("./OngRouter"));
const AdminRouter = lazy(() => import("./AdminRouter"));
const AuthModule = lazy(() => import("../features/auth/Auth"));
const VerifyEmail = lazy(() => import("../features/auth/VerifyEmail"));
const SharedDocument = lazy(() => import("../features/shared/SharedDocument"));
const PublicSurvey = lazy(() => import("../features/shared/PublicSurvey"));

// base url of the website
const { PUBLIC_URL } = process.env;

const AppRouter = () => {
	return (
		<BrowserRouter basename={PUBLIC_URL}>
			<Suspense fallback={<PageLoader fullScreen />}>
				<Routes>
					<Route>
						{/* PLAN-010 Phase 7: Admin dashboard route */}
						<Route path="/admin/*" element={<AdminRouter />} />

						<Route path="/personal/*" element={<PrivateRouter />} />
						<Route path="/profesional/*" element={<ProfesionalRouter />} />
						<Route path="/ong/*" element={<OngRouter />} />

					<Route path="/verify-email" element={<VerifyEmail />} />
				<Route path="/compartido/:token" element={<SharedDocument />} />
				<Route path="/encuesta-publica/:token" element={<PublicSurvey />} />
				<Route index path="/*" element={<AuthModule />} />
					</Route>
				</Routes>
			</Suspense>
		</BrowserRouter>
	);
};

export default AppRouter;
